/*
 *  Header Section
 *    Provides scripts for elements within the header section.
 *
 *  Version:
 *    1.0.0 - 2018/01/08
 */
import $ from 'jquery';
import { register, ShopifySection } from './../ShopifySection';
import { CLASS_STICKY } from '../../tools/constants/classes';
import { MobileMenu, MOBILE_MENU_SELECTOR } from './../../objects/menu/MobileMenu';
import { DesktopMenu, DESKTOP_MENU_SELECTOR } from './../../objects/menu/DesktopMenu';
import { getCurrentCart, ON_CART_FINISHED } from '@process-creative/slate-theme-tools';

export const CONTAINER_SELECTOR = '[data-header-container]';
export const SELECTOR_INNER_CONTAINER = '[data-header-container-inner]';
export const SELECTOR_INNER = '[data-header-inner]';
export const CART_COUNTER = '[data-cart-counter]';
export const ATTR_INITIAL_BG = 'data-header-initial';
export const TOP_BAR_SELECTOR = '[data-topbar]';
export const SALE_PROMOBAR_SELECTOR = '[data-sale-promobar]';
export const DESKTOP_MENU_SUBMENU_SELECTOR = '[data-desktop-submenu]';
export const SEARCH_INPUT = '[data-search-input]';
export const SEARCH_FORM = '[data-search-form]';

export const CLASS_BACKGROUND = 'has-background';
export const CLASS_FIXED = 'is-fixed';
export const CLASS_SALES_PROMO_ACTIVE = 'sales-promo-active';
export const CLASS_VALUE = 'has-value';

export class HeaderSection extends ShopifySection {
  constructor(container) {
    super(container);

    this.container = container;
    this.containerInner = container.find(SELECTOR_INNER_CONTAINER);
    this.mobileMenu = new MobileMenu(container.find(MOBILE_MENU_SELECTOR));
    this.desktopMenu = new DesktopMenu(container.find(DESKTOP_MENU_SELECTOR), container);
    this.form = container.find(SEARCH_FORM);

    this.inner = container.find(SELECTOR_INNER);
    this.cartCounter = container.find(CART_COUNTER);
    this.salesPromo = $(SALE_PROMOBAR_SELECTOR);
    this.desktopMenu = container.find(DESKTOP_MENU_SUBMENU_SELECTOR);
    this.searchInput = container.find(SEARCH_INPUT);

    this.previousTop = 0;
    this.fixed = $(TOP_BAR_SELECTOR).height();

    $(document).on(ON_CART_FINISHED, () => this.updateCartCount());
    $(window).on('scroll resize', () => this.isScroll());
    this.updateCartCount();
    this.initialState();

    this.checkHeaderPosition();

    $(document).on('click', SEARCH_INPUT, () => this.searchFixed());
    this.hideSearchIcon();
  }

  initialState() {
    this.hasBackground = (this.inner.attr(ATTR_INITIAL_BG) == CLASS_BACKGROUND);

    this.hasPromo = (this.salesPromo.length > 0);
    if(this.hasPromo) {
      this.container.addClass(CLASS_SALES_PROMO_ACTIVE);
      this.container.removeClass(CLASS_FIXED);
      this.promoHeight = this.salesPromo.height();
    }

    if(this.hasBackground && !this.hasPromo) return;
  }

  checkHeaderPosition() {
    if(!document.body.classList.contains('c-page--index')) return;

    const containerElement = this.container[0];
    if(!containerElement) return;

    const elementPromobar = containerElement.querySelector(TOP_BAR_SELECTOR);
    if(!elementPromobar) return;

    const promoBarDistance = elementPromobar.clientHeight;

    let top = window.scrollY;

    // Decide whether the header is in a sticky state or not
    if(top > promoBarDistance) {
      containerElement.classList.add(CLASS_STICKY);
    } else {
      containerElement.classList.remove(CLASS_STICKY);
    }

    // Reset previous top
    this.previousTop = top;

    requestAnimationFrame(() => this.checkHeaderPosition());
  }

  searchFixed() {
    if (this.form.length > 0) {
      this.form.toggleClass(CLASS_FIXED);
    }
  }

  isScroll() {
    // add sticky class to header on collection pages
    if(!document.body.classList.contains('c-page-template--collection')) return;

    if (window.pageYOffset > this.fixed) {
      this.container.addClass(CLASS_STICKY);
    } else {
      this.container.removeClass(CLASS_STICKY);
    }
  }

  hideSearchIcon() {
    if(!this.searchInput) return;
    [...this.searchInput].forEach(element => {
      $(element).on('input', e => {
        if (e.currentTarget.value.length > 0) {
          $(e.currentTarget).closest('.c-header__search').addClass(CLASS_VALUE);
        } else {
          $(e.currentTarget).closest('.c-header__search').removeClass(CLASS_VALUE);
        }
      });
    });
  }

  updateCartCount() {
    let cart = getCurrentCart();
    if(cart.item_count > 0) this.cartCounter.text(cart.item_count);
  }
}

register(CONTAINER_SELECTOR, HeaderSection);
